import { FC, useRef } from "react";
import { ImageSchemaItem } from "@data-root/types";
import { SchemaItemProps, useField } from "@data-root/react";
import { View } from "@data-root/react";
import { Skeleton, Typography, Image, Space, Button } from "antd";
import ParentSize from "../ParentSize";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";

const { Title } = Typography;

export const ImageDetail: FC<SchemaItemProps<ImageSchemaItem>> = ({ item }) => {
  const ref = useRef(null);

  const { loaded, name, show, displayValue } = useField(item);

  if (!show) return null;

  return (
    <View ref={ref} style={{ width: "100%" }}>
      <Title level={5}>{name}</Title>

      <div style={divStyle}>
        <ParentSize>
          {({ width }) =>
            loaded ? (
              displayValue ? (
                <Image
                  src={displayValue}
                  style={{
                    width: width,
                    height: 200,
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Skeleton.Image
                  style={{
                    width: width,
                    height: 200,
                  }}
                />
              )
            ) : (
              <Skeleton.Image
                active
                style={{
                  width: width,
                  height: 200,
                }}
              />
            )
          }
        </ParentSize>
      </div>
    </View>
  );
};

const divStyle = {
  width: "100%",
  height: 200,
};
